import PropTypes from "prop-types"
import { color } from "helpers/styled"
import styled, { keyframes } from "styled-components"

const fill = keyframes`
  0% {
    stroke-dasharray: 40 242.6;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 141.3;
    stroke-dashoffset: 141.3;
  }
  100% {
    stroke-dasharray: 40 242.6;
    stroke-dashoffset: 282.6;
  }
`

const Svg = styled.svg`
  display: flex;
  position: relative;
  align-content: space-around;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin: ${({ margin }) => margin || "0 auto"};
`

const Base = styled.circle`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  fill: none;
  stroke-linecap: round;
`

const Background = styled(Base)`
  stroke: ${color("white")}66;
  stroke-width: 8px;
`
const Loader = styled(Base)`
  stroke: ${color("white")};
  stroke-dasharray: 242.6;
  stroke-width: 5px;
  animation: ${fill} 1s cubic-bezier(1, 1, 1, 1) 0s infinite;
`

function AnimatedLoader({ className, ...rest }) {
  return (
    <Svg className={className} {...rest} viewBox="0 0 100 100">
      <Background cx="50" cy="50" r="45" />
      <Loader cx="50" cy="50" r="45" />
    </Svg>
  )
}

AnimatedLoader.defaultProps = {
  className: null
}

AnimatedLoader.propTypes = {
  className: PropTypes.string
}

export default AnimatedLoader
